export default class User {
  /**
   * User informations
   *
   * @param { string } firstName
   * @param { string } lastName
   */
  constructor(firstName, lastName) {
    this.firstName = firstName;
    this.lastName = lastName;
  }
}
